import React from "react";
import PropTypes from "prop-types";

import { socialMediaConfig } from "../../../config/config";

export default class InstagramDisplay extends React.Component {
  render() {
    const { imageURLs } = this.props;
    return (
      <div className="instagram-container">
        <div>FOLLOW US ON INSTAGRAM</div>
        <div>@whole_sol</div>
        <div>
          {imageURLs.map(url => (
            <div
              className="instagram-display-image"
              key={url}
              style={{ backgroundImage: `url(${url})` }}
            />
          ))}
        </div>
        <a
          href={socialMediaConfig.instagram.link}
          target="_blank"
          rel="noopener"
        >
          <button>SEE MORE +</button>
        </a>
      </div>
    );
  }
}

InstagramDisplay.propTypes = {
  imageURLs: PropTypes.arrayOf(PropTypes.string).isRequired
};



// WEBPACK FOOTER //
// ./src/components/InstagramDisplay/InstagramDisplay.jsx